import { Answer } from './Answer'
import { Company } from './Company'
import { Employee } from './Employee'
import { Form } from './Form'
import { Job } from './Job'
import { SBModel, SBModelUUID } from './SBmodel'

export interface Campaign extends SBModel {
  uuid: string
  name: string
  start: string
  softEnd: string
  hardEnd: string

  totalEmployees?: number
  totalSigned?: number
  totalAnswersManager?: number
  totalAnswersEmployee?: number

  //   Relations //
  employees: number[]
}

export interface CampaignEmployee extends SBModelUUID {
  campaign: Campaign
  employee: Employee
  job: Job
  company: Company
  manager: Employee
  form: number
  answers: Answer[]

  employeeComment?: string
  employeeSignedAt?: string
  employeeFulfilledAt?: string
  employeeProgression: {
    filled: number
    totalRequired: number
    progression: number
  }

  managerComment?: string
  managerSignedAt?: string
  managerFulfilledAt?: string
  managerProgression: {
    filled: number
    totalRequired: number
    progression: number
  }
}

export interface CampaignData {
  campaign: Campaign
  campaignEmployee: CampaignEmployee
  form: Form
}

export const isEmployee = (
  user: Employee,
  campaignEmployee: CampaignEmployee
): boolean => user !== undefined && campaignEmployee.employee.id === user.id
